export const getCurrentOnboardingVariant = (
  growthBookVariantId: string,
): string => `ab_variant_${growthBookVariantId || 'no_test'}`
